import Promise from 'bluebird'

export default function delayRequest(request, minTime = 1200) {
  return Promise.delay(minTime).return(request)
}
